<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>¿El inventario de operación es un valor nominal?</mat-label>
          <mat-select formControlName="isNominal">
            <mat-option [value]="true">SI</mat-option>
            <mat-option [value]="false">NO</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <!-- Se muestra solo si el usuario selecciona "SI" -->
      <div class="col-12 col-sm-6 col-md-6" *ngIf="form.get('isNominal')?.value === true">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor</mat-label>
          <input matInput placeholder="Valor" formControlName="numero" uppercase>
          
        </mat-form-field>
      </div>

      <!-- Se muestra solo si el usuario selecciona "NO" -->
      <div class="col-12 col-sm-6 col-md-6" *ngIf="form.get('isNominal')?.value === false">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor Inicial</mat-label>
          <input type="number" matInput placeholder="Valor Inicial" formControlName="vInicial">
          <mat-error *ngIf="form.hasError('valoresInvalidos')">Debe ser mayor que 'Valor Final'</mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6 col-md-6" *ngIf="form.get('isNominal')?.value === false">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor Final</mat-label>
          <input type="number" matInput placeholder="Valor Final" formControlName="vFinal">
          <mat-error *ngIf="form.hasError('valoresInvalidos')">Debe ser mayor que 'Valor Final'</mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="m-1" type="submit">
      <i class="fa fa-save"></i> Guardar
    </button>
    <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
      <i class="fa fa-remove fa-solid"></i> Cancelar
    </button>
  </mat-dialog-actions>
</form>
